









































import mixins from 'vue-typed-mixins'
import DiaryMixin from '../../DiaryMixin'

import Conflict from './Conflict.vue'

export default mixins(DiaryMixin).extend({
  components: { Conflict },
})
